import { render } from "./cardAbuttingModel.vue?vue&type=template&id=5f990968"
import script from "./cardAbuttingModel.vue?vue&type=script&lang=js"
export * from "./cardAbuttingModel.vue?vue&type=script&lang=js"

import "./cardAbuttingModel.vue?vue&type=style&index=0&id=5f990968&lang=sass"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__